'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'wand-magic-sparkles';
var width = 576;
var height = 512;
var aliases = ["magic-wand-sparkles"];
var unicode = 'e2ca';
var svgPathData = ['M55.6 423L313.7 164.9c.2 .3 .4 .5 .6 .7l64 64c.2 .2 .5 .4 .7 .6L121 488.4c-9.4 9.4-24.6 9.4-33.9 0L55.6 457c-9.4-9.4-9.4-24.6 0-33.9z', 'M455 23.6c9.4-9.4 24.6-9.4 33.9 0L520.4 55c9.4 9.4 9.4 24.6 0 33.9L390.3 219.1c-.2-.3-.4-.5-.6-.7l-64-64c-.2-.2-.5-.4-.7-.6L455 23.6zM55.6 423L313.7 164.9c.2 .3 .4 .5 .6 .7l64 64c.2 .2 .5 .4 .7 .6L121 488.4c-9.4 9.4-24.6 9.4-33.9 0L55.6 457c-9.4-9.4-9.4-24.6 0-33.9zM443.7 12.3L44.3 411.7c-15.6 15.6-15.6 40.9 0 56.6l31.4 31.4c15.6 15.6 40.9 15.6 56.6 0L531.7 100.3c15.6-15.6 15.6-40.9 0-56.6L500.3 12.3c-15.6-15.6-40.9-15.6-56.6 0zM104 64c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 56-56 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l56 0 0 56c0 4.4 3.6 8 8 8s8-3.6 8-8l0-56 56 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-56 0 0-56zM480 312c-4.4 0-8 3.6-8 8l0 56-56 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l56 0 0 56c0 4.4 3.6 8 8 8s8-3.6 8-8l0-56 56 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-56 0 0-56c0-4.4-3.6-8-8-8zM232 32c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 24-24 0c-4.4 0-8 3.6-8 8s3.6 8 8 8l24 0 0 24c0 4.4 3.6 8 8 8s8-3.6 8-8l0-24 24 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-24 0 0-24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faWandMagicSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;